import { useEffect } from "react";

const removeBodyStyles = () => {
  document.body.setAttribute("style", "");
};

function removeModalBackgroundScroll({ showModal }) {
  useEffect(() => {
    if (showModal) {
      document.body.setAttribute("style", `overflow: hidden;`);
    } else {
      removeBodyStyles();
    }
  }, [showModal]);

  useEffect(() => {
    return () => {
      removeBodyStyles();
    };
  }, []);
}

export default removeModalBackgroundScroll;
